<template>
    <div class="ads" v-if="banner">
        <router-link :to="banner.local_url" v-if="banner.local_url != null">
            <img :src="banner.image" alt="" class="ad">
        </router-link>
        <a :href="banner.acf.url" target="_blank" v-else>
            <img :src="banner.image" alt="" class="ad">
        </a>
    </div>
</template>

<script>

export default {
    name: 'AdsComponent',
    components: {
    },
    props: {
    },
    data() {
        return {
        }
    },
    computed: {
        banner() {
            return this.$store.state.banners.wide
        }
    },
    methods: {
    },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
@import "@/assets/scss/queries";

.ads {
    max-width: calc(100vw - 2 * var(--side-padding));
    margin: 0 auto;
}

.ad {
    width: 100%;
    max-width: 100%;
}
</style>
